module.exports = __webpack_public_path__ + "img/10020.8c022aa5.jpg";